import { forwardRef } from 'react';
import Field from './Field';
import Icon from './Icon';

// §2.6 Input: raised fill, border-strong outline. Optional leading icon (e.g. search).
const Input = forwardRef(function Input({ label, hint, error, icon, className, ...rest }, ref) {
  return (
    <Field label={label} hint={hint} error={error} className={className}>
      {({ id, describedBy, invalid }) => {
        const input = <input ref={ref} id={id} className="ui-input" aria-describedby={describedBy} aria-invalid={invalid || undefined} {...rest} />;
        return icon ? <span className="ui-input-wrap"><Icon icon={icon} />{input}</span> : input;
      }}
    </Field>
  );
});
export default Input;
